export function isURLAnImage(url) {
  const ext = url.substr(url.lastIndexOf('.') + 1);
  return (
    ext === 'jpg' ||
    ext === 'jpeg' ||
    ext === 'png' ||
    ext === 'JPG' ||
    ext === 'PNG'
  );
}
